export const APP_VALUES_VISIBILITY_KEY = "patrimonio360-values-hidden";
export const LEGACY_DASHBOARD_VALUES_VISIBILITY_KEY = "patrimonio360-dashboard-values-hidden";

export const HIDDEN_VALUE_LABEL = "****";
export const HIDDEN_CURRENCY_LABEL = "R$ ****";
export const HIDDEN_PERCENTAGE_LABEL = "**%";

export const getStoredValuesHidden = () => {
  try {
    const appPreference = window.localStorage.getItem(APP_VALUES_VISIBILITY_KEY);

    if (appPreference != null) {
      return appPreference === "true";
    }

    return window.localStorage.getItem(LEGACY_DASHBOARD_VALUES_VISIBILITY_KEY) === "true";
  } catch {
    return false;
  }
};

export const persistValuesHidden = (valuesHidden) => {
  try {
    const serializedValue = valuesHidden ? "true" : "false";

    window.localStorage.setItem(APP_VALUES_VISIBILITY_KEY, serializedValue);
    window.localStorage.setItem(LEGACY_DASHBOARD_VALUES_VISIBILITY_KEY, serializedValue);
  } catch {
    // Ignore storage failures; the visibility toggle still works for the current session.
  }
};
